module.exports = __webpack_public_path__ + "img/Capillaria.2ed38ee7.png";